.band {
  /* Lifted off the page and the footer below it (both the deepest asphalt), so the
     closing call to action reads as its own band. */
  background: var(--surface-raised);
  border-block: 1px solid var(--border);
}
.inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-6);
}
.text {
  max-width: 36rem;
  margin: var(--sp-3) 0 0;
  font-size: var(--fs-md);
}

/* ---- statement: the home page's ending ------------------------------------ */
.statement {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  padding-block: clamp(var(--sp-20), 12vw, 10rem);
  border-top: 1px solid var(--border);
  text-align: center;
}
.backdrop {
  position: absolute;
  inset: 0;
  z-index: -2;
  height: 100%;
  opacity: 0.55;
}
/* Darkens the image towards the middle, where the text sits, and into the footer below. */
.statement::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background:
    radial-gradient(ellipse 60% 70% at 50% 50%, rgba(8, 13, 19, 0.9), rgba(8, 13, 19, 0.35)),
    linear-gradient(180deg, transparent 60%, var(--surface-dark));
}
.statementInner {
  display: grid;
  justify-items: center;
  gap: var(--sp-6);
}
.statementTitle {
  max-width: 18ch;
  font-size: clamp(2.5rem, 1.4rem + 3.4vw, var(--fs-6xl));
  line-height: var(--lh-display);
  letter-spacing: var(--tracking-display);
  text-wrap: balance;
}
.statementText {
  max-width: 34rem;
  margin: 0;
  font-size: var(--fs-lg);
}
.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: var(--sp-4) var(--sp-8);
  margin-top: var(--sp-2);
}
.secondary {
  font-weight: 600;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.secondary:hover {
  color: var(--accent-text);
}
